import { render } from "./ValidationOneTransfertPage.vue?vue&type=template&id=83735b66&ts=true"
import script from "./ValidationOneTransfertPage.vue?vue&type=script&lang=ts"
export * from "./ValidationOneTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__